/**
 * Telepost Api
 * Для авторизации зайти http://local.telepost.me/  В `/etc/hosts` добавить запись  ```sh 127.0.0.1 local.telepost.me ``` При авторизации добавть `Bearer` перед токеном         
 *
 * OpenAPI spec version: 2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddBotDto } from '../model/addBotDto';
import { BotResponse } from '../model/botResponse';
import { BotValidateResult } from '../model/botValidateResult';
import { BotsListResponse } from '../model/botsListResponse';
import { SetBotTokenDto } from '../model/setBotTokenDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BotsService {

    protected basePath = 'http://localhost/api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get file with bot
     * 
     * @param fileId 
     * @param botId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cdnFile(fileId: string, botId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cdnFile(fileId: string, botId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cdnFile(fileId: string, botId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cdnFile(fileId: string, botId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling cdnFile.');
        }

        if (botId === null || botId === undefined) {
            throw new Error('Required parameter botId was null or undefined when calling cdnFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/bot-cdn/${encodeURIComponent(String(botId))}/file/${encodeURIComponent(String(fileId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get photo with bot
     * 
     * @param fileId 
     * @param botId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cdnPhoto(fileId: string, botId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public cdnPhoto(fileId: string, botId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public cdnPhoto(fileId: string, botId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public cdnPhoto(fileId: string, botId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fileId === null || fileId === undefined) {
            throw new Error('Required parameter fileId was null or undefined when calling cdnPhoto.');
        }

        if (botId === null || botId === undefined) {
            throw new Error('Required parameter botId was null or undefined when calling cdnPhoto.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/bot-cdn/${encodeURIComponent(String(botId))}/photo/${encodeURIComponent(String(fileId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create bot with token
     * 
     * @param AddBotDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createBot(AddBotDto: AddBotDto, observe?: 'body', reportProgress?: boolean): Observable<BotResponse>;
    public createBot(AddBotDto: AddBotDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BotResponse>>;
    public createBot(AddBotDto: AddBotDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BotResponse>>;
    public createBot(AddBotDto: AddBotDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (AddBotDto === null || AddBotDto === undefined) {
            throw new Error('Required parameter AddBotDto was null or undefined when calling createBot.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BotResponse>(`${this.basePath}/bots`,
            AddBotDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete bot by id
     * 
     * @param botId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteBot(botId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteBot(botId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteBot(botId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteBot(botId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (botId === null || botId === undefined) {
            throw new Error('Required parameter botId was null or undefined when calling deleteBot.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/bots/${encodeURIComponent(String(botId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all user bots
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBots(observe?: 'body', reportProgress?: boolean): Observable<BotsListResponse>;
    public getBots(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BotsListResponse>>;
    public getBots(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BotsListResponse>>;
    public getBots(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<BotsListResponse>(`${this.basePath}/bots`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update bot token
     * 
     * @param SetBotTokenDto 
     * @param botId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setBotToken(SetBotTokenDto: SetBotTokenDto, botId: string, observe?: 'body', reportProgress?: boolean): Observable<BotResponse>;
    public setBotToken(SetBotTokenDto: SetBotTokenDto, botId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BotResponse>>;
    public setBotToken(SetBotTokenDto: SetBotTokenDto, botId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BotResponse>>;
    public setBotToken(SetBotTokenDto: SetBotTokenDto, botId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (SetBotTokenDto === null || SetBotTokenDto === undefined) {
            throw new Error('Required parameter SetBotTokenDto was null or undefined when calling setBotToken.');
        }

        if (botId === null || botId === undefined) {
            throw new Error('Required parameter botId was null or undefined when calling setBotToken.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<BotResponse>(`${this.basePath}/bots/${encodeURIComponent(String(botId))}/set-token`,
            SetBotTokenDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Apply bot webhook url
     * 
     * @param botId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setBotWebhook(botId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setBotWebhook(botId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setBotWebhook(botId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setBotWebhook(botId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (botId === null || botId === undefined) {
            throw new Error('Required parameter botId was null or undefined when calling setBotWebhook.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<any>(`${this.basePath}/bots/${encodeURIComponent(String(botId))}/set-webhook`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Validate bot token
     * 
     * @param botId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateToken(botId: string, observe?: 'body', reportProgress?: boolean): Observable<BotValidateResult>;
    public validateToken(botId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BotValidateResult>>;
    public validateToken(botId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BotValidateResult>>;
    public validateToken(botId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (botId === null || botId === undefined) {
            throw new Error('Required parameter botId was null or undefined when calling validateToken.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.patch<BotValidateResult>(`${this.basePath}/bots/${encodeURIComponent(String(botId))}/validate`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
